import * as React from 'react';
import { CalculatedField } from '../../atoms/calculatedFields';
import { TableRow } from '../orders/templateOrders/style/Style';
import { ValueInnerToNode } from '../reports/interpretor/ReportInterpretor';
import { scaleValueOf, standaloneColor } from '../map/colorScale';

// A calculated field of a promotion holds a report value ({"int": 3},
// {"percentage": ...}): shown as the companies listing shows its
// calculated values, with the field's colours.

export function CalculatedValueCell(props: { field: CalculatedField, value: unknown }): JSX.Element {
	if (props.value === null || props.value === undefined) return <TableRow>-</TableRow>;
	const color = standaloneColor(props.field.display_options, 'CalculatedField', props.value);
	 
	return <TableRow><ValueInnerToNode value={props.value as any} emptyTile color={color} /></TableRow>;
}

/** The value a calculated cell sorts on: its number when it has one. */
export function calculatedSortValue(value: unknown): number | undefined {
	return value === null || value === undefined ? undefined : scaleValueOf('CalculatedField', value)?.value;
}
